// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"788edd6d","344":"accbc23f","403":"36e0793f","644":"bf340e65","748":"fa16a074","944":"541470ab"}[chunkId] + ".chunk.js";
};